import React, {useRef, useState} from "react";
import InputPhone from "../Input/InputPhone";
import {content} from "../../services/content";
import Button from "../Button/Button";
import ErrorTextBlocked from "../ErrorTextBlocked/ErrorTextBlocked";
import {EnumUrlsPages} from "../../services/Enum";
import {createPortal} from "react-dom";
import ModalFormFeedback from "../ModalFormFeedback/ModalFormFeedback";
import {SelectValuesFormSimple} from "../../services/content/Constants";
import {CSSTransition} from "react-transition-group";
import SuccessForm from "../SuccessForm/SuccessForm";
import InputPhoneStandalone from "../Input/InputPhoneStandalone";
import ButtonStandalone from "../Button/ButtonStandalone";
import {IContactForms} from "../../redux/initState/InterfacesState";

interface Props {
  contactForms: IContactForms;
}

const MainBlockForm = ({contactForms}: Props) => {
  const [phone, setPhone] = useState('+7');
  const [serverText, setServerText] = useState<string | null>(null);
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showFeedback, setShowFeedback] = useState(false);

  const success = () => {
    setPhone('+7');
    setSuccessShow(true);
    // setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
  };

  const ClosedModal = () => setSuccessShow(false);

  const handleFormSubmit = async(e: any) => {
    e.preventDefault();
    console.log('phone number on submit', phone);
    setShowFeedback(true);
  }

  const nodeRefSuccess = useRef(null);

  return (
    <form className={'main-block__consultation'} onSubmit={handleFormSubmit}>
      <CSSTransition
        in={successShow}
        nodeRef={nodeRefSuccess}
        timeout={{ appear: 200, enter: 0, exit: 200 }}
        classNames="css-transition-modal"
        unmountOnExit
      >
        <div className="main-block__success-msg">
          <div className="main-block__success">
            <SuccessForm refCss={nodeRefSuccess} closed={ClosedModal} />
          </div>
        </div>
      </CSSTransition>
      <InputPhoneStandalone
        label={content.mainBlock.phone}
        name="phone"
        value={phone}
        onChange={(e: any) => setPhone(e.target.value)}
        error={serverText}/>

      <ButtonStandalone text={content.mainBlock.getProposal} size="M" disabled={disableBtn}/>

      {createPortal(
        <ModalFormFeedback
          hasCssTransition
          showForm={showFeedback}
          id="feedback"
          title={content.header.textModalFeedback}
          select={{ options: SelectValuesFormSimple }}
          closedModal={() => setShowFeedback(false)}
          phoneNumber={phone}
          contactForms={contactForms}
        />,
        document.body
      )}
    </form>
  )
}

export default MainBlockForm;
